import styled from 'styled-components';
// We still import the originals to build upon them
import {
  DocumentTable as OriginalDocumentTable,
  TableHead as OriginalTableHead,
  TableRow as OriginalTableRow,
  TableCell as OriginalTableCell
} from '../common/common.styles';

// A specific style for the role dropdown (your original style)
export const RoleSelect = styled.select`
  padding: 8px 10px;
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 14px;
  background-color: ${({ theme }) => theme.inputBg};
  color: ${({ theme }) => theme.heading};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }
`;

// --- NEW RESPONSIVE STYLES ---

// We create new components that extend the originals with responsive rules
export const DocumentTable = styled(OriginalDocumentTable)`
  /* No changes needed for the table itself, but we define it for clarity */
`;

export const TableHead = styled(OriginalTableHead)`
  /* This will hide the original table headers on mobile */
  @media (max-width: 768px) {
    display: none;
  }
`;

export const TableRow = styled(OriginalTableRow)`
  /* This turns each row into a card on mobile */
  @media (max-width: 768px) {
    display: block;
    border: 1px solid ${({ theme }) => theme.cardBorder};
    border-radius: 8px;
    margin-bottom: 15px;
    
    /* Remove the default bottom border in card view */
    border-bottom: 1px solid ${({ theme }) => theme.cardBorder};

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const TableCell = styled(OriginalTableCell)`
  /* This styles each cell inside the mobile card */
  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: right;
    padding: 12px 15px;
    border-bottom: 1px solid ${({ theme }) => theme.cardBorder};

    /* This creates the text label (e.g., "Name:") before the data */
    &::before {
      content: attr(data-label);
      font-weight: bold;
      text-align: left;
      margin-right: 10px;
      color: ${({ theme }) => theme.heading};
    }
    
    /* Remove border from the last cell in the card */
    &:last-of-type {
      border-bottom: none;
    }

    /* Ensure text in the first cell is normal weight on mobile */
     &:first-child {
      font-weight: normal;
    }
  }
`;